export const global = {
    managerURL: "/incluirBO",
};